// Real project photos uploaded by client (Prime Build Design LTD)
export const CLIENT_PROJECTS = [
  {
    id: "wp-renovation-1",
    title: "Wembley Park Full Refurbishment",
    category: "Renovation",
    location: "Wembley Park, HA9",
    year: "2023",
    blurb:
      "Whole-ground-floor refurbishment featuring wet underfloor heating, full re-plaster and structural reconfiguration.",
    img: "https://customer-assets.emergentagent.com/job_about-me-143/artifacts/jqeo9yr0_IMG-20230124-WA0007.jpg",
  },
  {
    id: "wp-ufh-2",
    title: "Wet Underfloor Heating Install",
    category: "Renovation",
    location: "Wembley Park, HA9",
    year: "2023",
    blurb:
      "Wet underfloor heating system installed across an open-plan kitchen-diner — pipework, screed and zoning.",
    img: "https://customer-assets.emergentagent.com/job_about-me-143/artifacts/w0w1htlw_IMG-20230124-WA0008.jpg",
  },
  {
    id: "richmond-extension-ufh",
    title: "Richmond Kitchen Extension",
    category: "Extension",
    location: "Richmond, TW9",
    year: "2023",
    blurb:
      "Rear-kitchen extension with aluminium bifold doors, freshly poured UFH screed and timber stud build-up.",
    img: "https://customer-assets.emergentagent.com/job_about-me-143/artifacts/9kyu24qj_IMG-20230124-WA0010.jpg",
  },
  {
    id: "ealing-rear-extension",
    title: "Ealing Rear Extension",
    category: "Extension",
    location: "Ealing, W5",
    year: "2023",
    blurb:
      "Single-storey brick rear extension with GRP flat roof and steel structural opening into the existing kitchen.",
    img: "https://customer-assets.emergentagent.com/job_about-me-143/artifacts/nwhs9b51_IMG-20230602-WA0005.jpg",
  },
  {
    id: "wembley-side-return-opening",
    title: "Wembley Side-Return — Structural Opening",
    category: "Extension",
    location: "Wembley Park, HA9",
    year: "2023",
    blurb:
      "Removing the original rear wall and installing the new structural opening — preparing the existing home to connect into a new side-return extension.",
    img: "https://customer-assets.emergentagent.com/job_about-me-143/artifacts/t2ffmifq_IMG-20230602-WA0006.jpg",
  },
  {
    id: "chiswick-steel-firstfix",
    title: "Chiswick Refurbishment — Steel & First Fix",
    category: "Renovation",
    location: "Chiswick, W4",
    year: "2021",
    blurb:
      "Whole-floor strip-out with new steel beams installed, suspended-ceiling framework set out and plasterboard staged for first fix.",
    img: "https://customer-assets.emergentagent.com/job_about-me-143/artifacts/45t87hji_IMG-20210531-WA0115.jpg",
  },
  {
    id: "hampstead-newbuild-brick-detail",
    title: "Hampstead New Build — Corbelled Brick Detail",
    category: "New Build",
    location: "Hampstead, NW3",
    year: "2021",
    blurb:
      "Bespoke corbelled buff-brick column with raked dark mortar joints — precision masonry detail on a ground-up domestic new build.",
    img: "https://customer-assets.emergentagent.com/job_about-me-143/artifacts/lgzszx01_IMG-20210531-WA0078.jpg",
  },
  {
    id: "hampstead-newbuild-buff-facade",
    title: "Hampstead New Build — Buff Brick Facade",
    category: "New Build",
    location: "Hampstead, NW3",
    year: "2021",
    blurb:
      "Buff-brick external leaf rising on full scaffolding — exterior masonry phase of a domestic new build.",
    img: "https://customer-assets.emergentagent.com/job_about-me-143/artifacts/4duic16z_IMG-20210531-WA0079.jpg",
  },
  {
    id: "hampstead-newbuild-cavity",
    title: "Hampstead New Build — Cavity Wall Blockwork",
    category: "New Build",
    location: "Hampstead, NW3",
    year: "2021",
    blurb:
      "Thermal blockwork inner leaf with full-fill insulation visible — the structural backbone behind the brick facade.",
    img: "https://customer-assets.emergentagent.com/job_about-me-143/artifacts/feq5wty8_IMG-20210531-WA0080.jpg",
  },
  {
    id: "hampstead-newbuild-shell-joists",
    title: "Hampstead New Build — Shell & First-Floor Joists",
    category: "New Build",
    location: "Hampstead, NW3",
    year: "2021",
    blurb:
      "Full structural shell complete with first-floor joists installed — ready for decking and the next masonry lift.",
    img: "https://customer-assets.emergentagent.com/job_about-me-143/artifacts/9aweenvd_IMG-20210531-WA0081.jpg",
  },
  {
    id: "ealing-completed-extension",
    title: "Ealing Two-Storey Side Extension — Completed",
    category: "Extension",
    location: "Ealing, W5",
    year: "2021",
    blurb:
      "Completed two-storey side extension with smooth white render, new uPVC casements, dormer above and a full Indian sandstone patio across the rear garden.",
    img: "https://customer-assets.emergentagent.com/job_about-me-143/artifacts/2gwfczdd_IMG-20210531-WA0036.jpg",
  },
  {
    id: "ealing-patio-install",
    title: "Ealing Extension — Sandstone Patio Install",
    category: "Extension",
    location: "Ealing, W5",
    year: "2021",
    blurb:
      "Indian sandstone paving laid on a full mortar bed in front of the newly rendered extension — the final external works phase before handover.",
    img: "https://customer-assets.emergentagent.com/job_about-me-143/artifacts/mxd3uuh0_IMG-20210531-WA0051.jpg",
  },
  {
    id: "chiswick-soldier-brickwork",
    title: "Chiswick Extension — External Brickwork & Soldier Course",
    category: "Extension",
    location: "Chiswick, W4",
    year: "2021",
    blurb:
      "Buff perforated brick external leaf with a soldier-course detail being set out by hand — a heritage-sensitive finish to match neighbouring properties.",
    img: "https://customer-assets.emergentagent.com/job_about-me-143/artifacts/rx8e6vlv_IMG-20210531-WA0088.jpg",
  },
  {
    id: "hampstead-extension-steel-joists",
    title: "Hampstead Extension — Steel Frame & Floor Joists",
    category: "Extension",
    location: "Hampstead, NW3",
    year: "2021",
    blurb:
      "Engineered steel beam frame with timber joists fixed across — a substantial open-plan extension with skylights and full-height glazing to come.",
    img: "https://customer-assets.emergentagent.com/job_about-me-143/artifacts/ymrgqvy2_IMG-20210531-WA0083.jpg",
  },
  {
    id: "wimbledon-bespoke-staircase",
    title: "Wimbledon Bespoke Oak Staircase",
    category: "Renovation",
    location: "Wimbledon, SW19",
    year: "2021",
    blurb:
      "Open-tread solid oak staircase paired with an integrated under-stair joinery system — every cabinet shop-fitted and hand-finished on site.",
    img: "https://customer-assets.emergentagent.com/job_about-me-143/artifacts/ybwvk4cq_IMG-20210202-WA0019.jpg",
  },
  {
    id: "wimbledon-understair-joinery",
    title: "Wimbledon Bespoke Under-Stair Storage",
    category: "Renovation",
    location: "Wimbledon, SW19",
    year: "2021",
    blurb:
      "Bespoke under-stair pull-out drawers and full-height cupboards — engineered to use every millimetre of the angled space below the new oak treads.",
    img: "https://customer-assets.emergentagent.com/job_about-me-143/artifacts/eve5qiuo_IMG-20210202-WA0020.jpg",
  },
  {
    id: "richmond-bathroom-refurb",
    title: "Richmond Walk-In Shower Bathroom",
    category: "Renovation",
    location: "Richmond, TW9",
    year: "2021",
    blurb:
      "Full bathroom refurbishment with grey metro-tile walls, frameless sliding-door walk-in shower, wall-hung vanity and concealed mirror cabinet.",
    img: "https://customer-assets.emergentagent.com/job_about-me-143/artifacts/4sp46gff_IMG-20210107-WA0011.jpg",
  },
  {
    id: "chiswick-kitchen-fitout",
    title: "Chiswick Modern Kitchen Fit-Out",
    category: "Renovation",
    location: "Chiswick, W4",
    year: "2021",
    blurb:
      "Handle-less white base units, warm oak full-height cabinetry and a matte-black quartz island with integrated induction hob and built-in appliances.",
    img: "https://customer-assets.emergentagent.com/job_about-me-143/artifacts/hqcvv8l6_IMG-20210202-WA0018.jpg",
  },
  {
    id: "ealing-driveway-block-paving",
    title: "Ealing Block-Paving Driveway",
    category: "Extension",
    location: "Ealing, W5",
    year: "2020",
    blurb:
      "Bespoke block-paved driveway with a compass-star centrepiece and dark-charcoal border course — a high-impact front-of-house transformation.",
    img: "https://customer-assets.emergentagent.com/job_about-me-143/artifacts/133vrtil_IMG-20201020-WA0011.jpg",
  },
  {
    id: "richmond-loft-ensuite-wide",
    title: "Richmond Loft Conversion — Ensuite Bathroom",
    category: "Extension",
    location: "Richmond, TW10",
    year: "2022",
    blurb:
      "Completed loft ensuite with Calacatta marble-effect porcelain walls, dark slate-tile floor, bespoke porthole window and twin Velux roof lights.",
    img: "https://customer-assets.emergentagent.com/job_about-me-143/artifacts/1v7962j6_IMG-20221223-WA0019.jpg",
  },
  {
    id: "richmond-loft-vanity",
    title: "Richmond Loft Ensuite — Industrial Vanity",
    category: "Extension",
    location: "Richmond, TW10",
    year: "2022",
    blurb:
      "Hand-built industrial-style vanity unit with rattan-topped surface, white vessel basin and matte-black brassware — paired against book-matched marble tiling.",
    img: "https://customer-assets.emergentagent.com/job_about-me-143/artifacts/dqvz33mm_IMG-20221223-WA0022.jpg",
  },
  {
    id: "richmond-loft-shower",
    title: "Richmond Loft Ensuite — Walk-In Shower",
    category: "Extension",
    location: "Richmond, TW10",
    year: "2022",
    blurb:
      "Frameless walk-in shower with a black slate tray, marble-effect surround and signature porthole window — natural light from two roof angles.",
    img: "https://customer-assets.emergentagent.com/job_about-me-143/artifacts/jxqb4j7h_IMG-20221223-WA0021.jpg",
  },
  {
    id: "richmond-loft-bedroom",
    title: "Richmond Loft Conversion — Bedroom",
    category: "Extension",
    location: "Richmond, TW10",
    year: "2022",
    blurb:
      "Finished loft bedroom — full plaster skim, dual-tone paint scheme, recessed downlights, plush carpet and a solid oak door ready for handover.",
    img: "https://customer-assets.emergentagent.com/job_about-me-143/artifacts/ciq8x63y_IMG-20221223-WA0020.jpg",
  },
  {
    id: "richmond-loft-master-bedroom",
    title: "Richmond Loft Conversion — Master Bedroom",
    category: "Extension",
    location: "Richmond, TW10",
    year: "2022",
    blurb:
      "Master loft bedroom featuring a black-panelled feature wall, statement spider pendant lighting, deep-pile carpet and a wide picture window overlooking the garden.",
    img: "https://customer-assets.emergentagent.com/job_about-me-143/artifacts/iydqm2he_IMG-20221223-WA0018.jpg",
  },
  {
    id: "richmond-reception-navy",
    title: "Richmond Whole-Home — Navy Reception Room",
    category: "Renovation",
    location: "Richmond, TW10",
    year: "2022",
    blurb:
      "Finished reception room in deep navy, with bespoke chimney breast detailing, satin-finish coving, dual aspect windows and a low-iron picture window framing the garden.",
    img: "https://customer-assets.emergentagent.com/job_about-me-143/artifacts/n9mljc7i_IMG-20221223-WA0013.jpg",
  },
  {
    id: "richmond-reception-bay",
    title: "Richmond Whole-Home — Reception Bay Window View",
    category: "Renovation",
    location: "Richmond, TW10",
    year: "2022",
    blurb:
      "Alternate angle of the navy reception room — full re-skim, premium emulsion two-coat finish, rebuilt chimney breast and crisply mitred skirtings.",
    img: "https://customer-assets.emergentagent.com/job_about-me-143/artifacts/9xgt19qz_IMG-20221223-WA0014.jpg",
  },
  {
    id: "richmond-blue-bedroom",
    title: "Richmond Whole-Home — Blue Bedroom",
    category: "Renovation",
    location: "Richmond, TW10",
    year: "2022",
    blurb:
      "Finished first-floor bedroom in a calm sky-blue with crisp white reveals — full plaster re-skim, new carpet and a wide picture window opening to the garden.",
    img: "https://customer-assets.emergentagent.com/job_about-me-143/artifacts/4a1b6txm_IMG-20221223-WA0015.jpg",
  },
  {
    id: "richmond-guest-bedroom-wardrobes",
    title: "Richmond Whole-Home — Guest Bedroom with Fitted Wardrobes",
    category: "Renovation",
    location: "Richmond, TW10",
    year: "2022",
    blurb:
      "Spare bedroom completed with full-height fitted wardrobes, hidden door joinery and a solid oak internal door — clean, classic and ready for handover.",
    img: "https://customer-assets.emergentagent.com/job_about-me-143/artifacts/pa2qxtar_IMG-20221223-WA0017.jpg",
  },
  {
    id: "richmond-kitchen-finished-diner",
    title: "Richmond Kitchen Extension — Finished Open-Plan Diner",
    category: "Extension",
    location: "Richmond, TW10",
    year: "2022",
    blurb:
      "Completed open-plan kitchen-diner: bespoke navy Shaker cabinetry, white-quartz worktops, herringbone solid-oak parquet, range cooker and a generous island anchoring the room.",
    img: "https://customer-assets.emergentagent.com/job_about-me-143/artifacts/sosyyn7j_IMG-20221223-WA0008.jpg",
  },
  {
    id: "richmond-kitchen-range-detail",
    title: "Richmond Kitchen — Range & Window Wall",
    category: "Extension",
    location: "Richmond, TW10",
    year: "2022",
    blurb:
      "Detail of the prep wall — twin-cavity range cooker with matt-black extractor, double-aspect windows above and a Belfast sink anchoring the run.",
    img: "https://customer-assets.emergentagent.com/job_about-me-143/artifacts/uv4x8wfq_IMG-20221223-WA0009.jpg",
  },
  {
    id: "richmond-kitchen-island-bifold",
    title: "Richmond Kitchen Extension — Island & Bifold Doors",
    category: "Extension",
    location: "Richmond, TW10",
    year: "2022",
    blurb:
      "Wide angle from the dining zone — central island, triple-pendant lighting and a five-leaf aluminium bifold door opening straight onto the garden.",
    img: "https://customer-assets.emergentagent.com/job_about-me-143/artifacts/5cg9pg7y_IMG-20221223-WA0010.jpg",
  },
  {
    id: "richmond-kitchen-island-pendants",
    title: "Richmond Kitchen — Island & Industrial Pendants",
    category: "Extension",
    location: "Richmond, TW10",
    year: "2022",
    blurb:
      "Hero shot of the island — solid oak top, beadboard navy panelling and three black industrial pendant lights against a backdrop of integrated American-style fridge-freezer.",
    img: "https://customer-assets.emergentagent.com/job_about-me-143/artifacts/amows11m_IMG-20221223-WA0011.jpg",
  },
  {
    id: "richmond-kitchen-bifold-view",
    title: "Richmond Kitchen Extension — Bifold View to Garden",
    category: "Extension",
    location: "Richmond, TW10",
    year: "2022",
    blurb:
      "Final reveal angle — looking through the dining space toward the bifold doors with the freshly landscaped garden beyond, the whole extension flooded with afternoon light.",
    img: "https://customer-assets.emergentagent.com/job_about-me-143/artifacts/pp7isz3u_IMG-20221223-WA0012.jpg",
  },
  {
    id: "richmond-kitchen-island-fridge",
    title: "Richmond Kitchen — Island & Larder Wall",
    category: "Extension",
    location: "Richmond, TW10",
    year: "2022",
    blurb:
      "Alternate angle of the island showing the floor-to-ceiling navy larder, integrated American-style fridge-freezer, undercounter wine cooler and triple industrial pendants overhead.",
    img: "https://customer-assets.emergentagent.com/job_about-me-143/artifacts/5om2gun6_IMG-20221223-WA0007.jpg",
  },
  {
    id: "richmond-loft-family-bathroom-bath-alt",
    title: "Richmond Loft Family Bathroom — Bath & Skylight",
    category: "Extension",
    location: "Richmond, TW10",
    year: "2022",
    blurb:
      "Wider angle of the family loft bathroom — bath, exposed mid-fix plumbing and the skylight above the toilet sending natural light down across the navy tiles.",
    img: "https://customer-assets.emergentagent.com/job_about-me-143/artifacts/md45hvpl_IMG-20221223-WA0004.jpg",
  },
  {
    id: "richmond-loft-family-bathroom-wide",
    title: "Richmond Loft Family Bathroom",
    category: "Extension",
    location: "Richmond, TW10",
    year: "2022",
    blurb:
      "Family loft bathroom finished in glossy navy bevelled metro tiles with crisp white grout, full-tiled bath surround, large-format grey porcelain floor and skylight above.",
    img: "https://customer-assets.emergentagent.com/job_about-me-143/artifacts/a1cl8lzn_IMG-20221223-WA0003.jpg",
  },
  {
    id: "richmond-loft-family-bathroom-bath",
    title: "Richmond Loft Family Bathroom — Bath Detail",
    category: "Extension",
    location: "Richmond, TW10",
    year: "2022",
    blurb:
      "Detail of the bath wall — navy bevelled metros traced precisely up to the eaves vault, with the bath panel fully tiled to match.",
    img: "https://customer-assets.emergentagent.com/job_about-me-143/artifacts/msi9pyk7_IMG-20221223-WA0002.jpg",
  },
];

// ---------------- Metadata enrichment ----------------
// Location centroid coordinates for the interactive map (lightweight — no geocoding at runtime).
export const AREA_COORDS = {
  wembley: { lat: 51.5580, lng: -0.2810 },
  ealing: { lat: 51.5130, lng: -0.3050 },
  richmond: { lat: 51.4600, lng: -0.3030 },
  chiswick: { lat: 51.4930, lng: -0.2760 },
  wimbledon: { lat: 51.4210, lng: -0.2100 },
  hampstead: { lat: 51.5540, lng: -0.1770 },
  croydon: { lat: 51.3760, lng: -0.0980 },
};

const CATEGORY_TO_SERVICE = {
  Renovation: "full-house-renovations-london",
  Extension: "house-extensions-london",
  "New Build": "new-build-contractors-london",
};

// Derive an area slug from a `location` string like "Wembley Park, HA9".
function deriveAreaSlug(location = "") {
  const lc = location.toLowerCase();
  for (const slug of Object.keys(AREA_COORDS)) {
    if (lc.includes(slug)) return slug;
  }
  return null;
}

// Small deterministic offset so multiple markers in the same area don't overlap.
function jitter(seed) {
  let x = 0;
  for (let i = 0; i < seed.length; i++) x = (x * 31 + seed.charCodeAt(i)) & 0xffff;
  return ((x % 200) - 100) / 12000; // ±~0.008deg
}

// Attach slug, area_slug, service_slug, lat, lng to every built-in project.
CLIENT_PROJECTS.forEach((p) => {
  p.slug = p.id;
  p.area_slug = deriveAreaSlug(p.location);
  p.service_slug = CATEGORY_TO_SERVICE[p.category] || null;
  if (p.area_slug && AREA_COORDS[p.area_slug]) {
    const c = AREA_COORDS[p.area_slug];
    p.lat = c.lat + jitter(p.id + "lat");
    p.lng = c.lng + jitter(p.id + "lng");
  }
});

export function findProjectBySlug(slug) {
  return CLIENT_PROJECTS.find((p) => p.slug === slug) || null;
}

// Hero image — cropped UK home photo (LOCAL FILE — copyright placeholder, replace with own-rights photo before deploy)
export const UK_HERO_IMG = "/hero-uk-home.jpg";
export const UK_HERO_OBJECT_POSITION = "center center";

// Supplementary UK home imagery (legacy fallbacks, unused but kept for reference)
export const UK_TERRACED_IMG =
  "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1200&q=80";
export const UK_INTERIOR_IMG =
  "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?auto=format&fit=crop&w=1200&q=80";
export const UK_KITCHEN_IMG =
  "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?auto=format&fit=crop&w=1200&q=80";
export const UK_LIVING_IMG =
  "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1200&q=80";
